import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadAuftragPositionListStatus: 'idle',
    loadAuftragPositionListError: undefined as any,
    loadAuftragPositionListLastArgs: undefined as any,
    loadAuftragPositionStatus: 'idle',
    loadAuftragPositionError: undefined as any,
    saveAuftragPositionStatus: 'idle',
    saveAuftragPositionError: undefined as any,
    deleteAuftragPositionStatus: 'idle',
    deleteAuftragPositionError: undefined as any,
    loadOptionssatzStatus: 'idle',
    loadOptionssatzError: undefined as any,

    auftragPositionList: [] as any[],
    formItem: undefined as any,
    optionssatz: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadAuftragPositionList = createAsyncThunk('auftragPositionSlice/loadAuftragPositionList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().auftragPositionSlice.loadAuftragPositionListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisauftpos/?action=gte&MIN_AUFTRAGID=${parentModel.HDR_ID}&MAX_AUFTRAGID=${parentModel.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadAuftragPositionListStatus } = getState().auftragPositionSlice
        return loadAuftragPositionListStatus !== 'pending'
    }
})

export const loadAuftragPosition = createAsyncThunk('auftragPositionSlice/loadAuftragPosition', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisauftpos/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadAuftragPositionStatus } = getState().auftragPositionSlice
        return loadAuftragPositionStatus !== 'pending'
    }
})

export const saveAuftragPosition = createAsyncThunk('auftragPositionSlice/saveAuftragPosition', async ({ auftragPosition }: any, { rejectWithValue }: any) => {
    let promises = []
    if (auftragPosition?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nurisauftpos/${ auftragPosition?.HDR_ID }/`,
            prepareData(auftragPosition),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nurisauftpos/`,
            prepareData(auftragPosition),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveAuftragPositionStatus } = getState().auftragPositionSlice
        return saveAuftragPositionStatus !== 'pending'
    }
})

export const deleteAuftragPosition = createAsyncThunk('auftragPositionSlice/deleteAuftragPosition', async ({ selectedIds }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/DeleteAuftragPosition/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: selectedIds.HDR_ID,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteAuftragPositionStatus } = getState().auftragPositionSlice
        return deleteAuftragPositionStatus !== 'pending'
    }
})

export const loadOptionssatz = createAsyncThunk('auftragPositionSlice/loadOptionssatz', async ({ auftragPosition }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/fnc_getkstoptionssatz/?KOSTENSTELLEKONTOID=${auftragPosition.KKONTOID}&OBJNR=${auftragPosition.OBJID.OBJNR}&DATUM='05.05.2026'`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadOptionssatzStatus } = getState().auftragPositionSlice
        return loadOptionssatzStatus !== 'pending'
    }
})

const AuftragPositionSlice = createSlice({
    name: 'auftragPositionSlice',
    initialState,
    reducers: {
        resetloadAuftragPositionListError: (state) => {
            state.loadAuftragPositionListError = undefined
        },
        resetloadAuftragPosition: (state) => {
            state.formItem = undefined
            state.loadAuftragPositionError = undefined
        },
        resetloadAuftragPositionError: (state) => {
            state.loadAuftragPositionError = undefined
        },
        resetsaveAuftragPosition: (state) => {
            state.formItem = undefined
            state.saveAuftragPositionError = undefined
        },
        resetsaveAuftragPositionError: (state) => {
            state.saveAuftragPositionError = undefined
        },
        resetdeleteAuftragPositionError: (state) => {
            state.deleteAuftragPositionError = undefined
        },
        resetloadOptionssatz: (state) => {
            state.optionssatz = undefined
            state.loadOptionssatzError = undefined
        },
        resetloadOptionssatzError: (state) => {
            state.loadOptionssatzError = undefined
        },
        removeFromAuftragPositionListById: (state, action) => {
            state.auftragPositionList = state.auftragPositionList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromAuftragPositionListByIds: (state, action) => {
            state.auftragPositionList = state.auftragPositionList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.auftragPositionList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadAuftragPositionListStatus = 'preloaded'
            state.loadAuftragPositionListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.auftragPositionList = []
            state.loadAuftragPositionListStatus = 'idle'
            state.loadAuftragPositionListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadAuftragPositionList.pending, (state) => {
            state.loadAuftragPositionListStatus = 'pending'
            state.loadAuftragPositionListError = undefined
        })
        builder.addCase(loadAuftragPositionList.fulfilled, (state, action) => {
            state.loadAuftragPositionListStatus = 'idle'

            if (!action.payload) { return }

            state.loadAuftragPositionListLastArgs = action.payload.args

            {
                state.auftragPositionList = action.payload.data

            }
        })
        builder.addCase(loadAuftragPositionList.rejected, (state, action) => {
            state.loadAuftragPositionListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadAuftragPositionListError = action.error.message
            } else {
                state.loadAuftragPositionListError = action.payload
            }
        })

        builder.addCase(loadAuftragPosition.pending, (state) => {
            state.loadAuftragPositionStatus = 'pending'
            state.loadAuftragPositionError = undefined
        })
        builder.addCase(loadAuftragPosition.fulfilled, (state, action) => {
            state.loadAuftragPositionStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.auftragPositionList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.auftragPositionList.push(newItem) }
                else { state.auftragPositionList[i] = { ...state.auftragPositionList[i], ...newItem } }
            }
        })
        builder.addCase(loadAuftragPosition.rejected, (state, action) => {
            state.loadAuftragPositionStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadAuftragPositionError = action.error.message
            } else {
                state.loadAuftragPositionError = action.payload
            }
        })

        builder.addCase(saveAuftragPosition.pending, (state) => {
            state.saveAuftragPositionStatus = 'pending'
            state.saveAuftragPositionError = undefined
        })
        builder.addCase(saveAuftragPosition.fulfilled, (state, action) => {
            state.saveAuftragPositionStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.auftragPositionList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.auftragPositionList.push(newItem) }
                else { state.auftragPositionList[i] = { ...state.auftragPositionList[i], ...newItem } }
            }
        })
        builder.addCase(saveAuftragPosition.rejected, (state, action) => {
            state.saveAuftragPositionStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveAuftragPositionError = action.error.message
            } else {
                state.saveAuftragPositionError = action.payload
            }
        })

        builder.addCase(deleteAuftragPosition.pending, (state) => {
            state.deleteAuftragPositionStatus = 'pending'
            state.deleteAuftragPositionError = undefined
        })
        builder.addCase(deleteAuftragPosition.fulfilled, (state, action) => {
            state.deleteAuftragPositionStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.auftragPositionList = state.auftragPositionList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.auftragPositionList = state.auftragPositionList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteAuftragPosition.rejected, (state, action) => {
            state.deleteAuftragPositionStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteAuftragPositionError = action.error.message
            } else {
                state.deleteAuftragPositionError = action.payload
            }
        })

        builder.addCase(loadOptionssatz.pending, (state) => {
            state.loadOptionssatzStatus = 'pending'
            state.loadOptionssatzError = undefined
        })
        builder.addCase(loadOptionssatz.fulfilled, (state, action) => {
            state.loadOptionssatzStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.optionssatz = newItem
            }
        })
        builder.addCase(loadOptionssatz.rejected, (state, action) => {
            state.loadOptionssatzStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadOptionssatzError = action.error.message
            } else {
                state.loadOptionssatzError = action.payload
            }
        })

    }
})

export const {
    resetloadAuftragPositionListError,
    resetloadAuftragPosition,
    resetloadAuftragPositionError,
    resetsaveAuftragPosition,
    resetsaveAuftragPositionError,
    resetdeleteAuftragPositionError,
    resetloadOptionssatz,
    resetloadOptionssatzError,
    removeFromAuftragPositionListById,
    removeFromAuftragPositionListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = AuftragPositionSlice.actions
export default AuftragPositionSlice.reducer
